export default {
    'searchList': {
        'searchTxt': [{
            'name': '运输单号',
            'value': 'mddrTaskNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '发车单号',
            'value': 'mddrDoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '运输单状态',
            'value': 'ettaStatus',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_TRANSPORT_TASK_STATUS',
            'unfold': true,
            'multiple': false
        }, {
            'name': '上传状态',
            'value': 'mddrElectronicExist',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_LTMS_UPLOAD_STATUS',
            'unfold': true,
            'multiple': false
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'timeNum': 30,
            'unfold': true,
            'span': 6
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'height': 400,
        'leftWidth': 150,
        'selectBtn': true,
        'columns': [
            {
                'label': '运输单号',
                'prop': 'mddrTaskNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '合同编号',
                'prop': 'ettaContractNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户订单号',
                'prop': 'mddrCustomerOrderNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '发车单号',
                'prop': 'mddrDoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输单状态',
                'prop': 'ettaStatusType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '上传状态',
                'prop': 'mddrElectronicExistType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '签收状态',
                'prop': 'mddrStatusType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户',
                'prop': 'mddrCustomEbcuNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '路线',
                'prop': 'mddrLineName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '司机',
                'prop': 'mddrDrivers',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '车牌号',
                'prop': 'mddrCarNos',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '联系方式',
                'prop': 'mddrDriversTel',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '发车时间',
                'prop': 'ettaDepartDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '要求上传回单时间',
                'prop': 'ettaYqUnloadedDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '上传时间',
                'prop': 'mddrUploadDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '签收时间',
                'prop': 'mddrTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '物流订单号',
                'prop': 'mddrLogisticsOrderNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运单号',
                'prop': 'ettaWorkOrderNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '直通宝标识',
                'prop': 'ztbzcldType',
                'sort': true,
                'width': '148px'
            }],
        'action': [
            {
                'type': 'text',
                'label': '上传',
                'size': 'mini',
                'event': 'upload',
                'ifHas': '05050101'
            },
            {
                'type': 'text',
                'label': '查看附件',
                'size': 'mini',
                'event': 'showAccessory',
                'ifHas': '05050102'
            }
        ],
        'leftOperation': true
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    },
    'searchTotalTitle': [
        {
            'name': '发车时间',
            'value': 'departTime',
            'startTime': 'mddrEtdoDepartDateFrom',
            'endTime': 'mddrEtdoDepartDateTo',
            'startPlaceholder': '发布开始日期',
            'endPlaceholder': '发布结束日期',
            'type': 'time',
            'span': 7
        }, {
            'name': '客户',
            'value': 'ebcuNameCn',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#mddrCustomEbcuCode', 'ebcuNameCn'],
            'span': 4
        }, {
            'name': '客户订单号',
            'value': 'mddrCustomerOrderNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '合同编号',
            'value': 'ettaContractNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '集拼号',
            'value': 'ettaAssighNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '目的城市',
            'value': 'ebplNameCn1',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地市名称' },
                { 'prop': 'ebplCode', 'value': '目的地市编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地省名称' },
                { 'prop': 'ebplCode', 'value': '目的地市编码' }
            ],
            'cbParams': [
                'ebplCode#taskToCityCode', 'ebplNameCn#ebplNameCn1'
            ],
            'advanceUrl': '/searchEbPlacePage?ebplType=PLACE_CITY',
            'advanceCode': 'taskToCityCode'
        }, {
            'name': '签收状态',
            'value': 'mddrStatus',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_TS_DELIVERY_RECEIPT_STATUS',
            'multiple': false
        }, {
            'name': '物流订单号',
            'value': 'mddrLogisticsOrderNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '运单号',
            'value': 'mddrWorkOrderNo',
            'type': 'input',
            'span': 3
        }
    ]
};
